// @flow

export function productIds (products: Array<any>): string {
  return products
    .flatMap(productsItem => productsItem.productId)
    .filter(productId => Boolean(productId))
    .join(',')
}

export function getProductsUtilityMax (products: Array<any>): number {
  if (!products) return NaN
  return Math.max(...products.map(product => product.utility))
}

export function getProductsUtilityAverage (products: Array<any>): number {
  if (!products) return NaN
  return products.map(product => product.utility).reduce((acc, utility) => acc + utility, 0) / products.length || NaN
}
